import UserPointHistoryContainer from './UserPointHistoryContainer';
export default UserPointHistoryContainer;
